import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer-section">
            <div className="footer-container">
                <div className="footer-main">
                    <div className="footer-col-1">
                        <h2>Let's Connect</h2>
                        <p>
                            Prime Rehab Industries manufactures high-quality physiotherapy and rehabilitation equipment designed for clinics, hospitals, and rehabilitation centres.
                        </p>
                    </div>

                    <div className="footer-col-2">
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/products">Products</Link></li>
                            <li><Link to="/services">Services</Link></li>
                          {/*   <li><Link to="/blog">Blog</Link></li> */}
                            <li><Link to="/catalogue">Catalogue</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="footer-col-3">
                        <address>
                            Prime Rehab Industries<br />
                            Chennai, Tamil Nadu, India
                        </address>
                        <div className="footer-contact-info">
                            <a href="mailto:primerehabt1@gmail.com">primerehaboffl@gmail.com</a>
                            <a href="tel:+919994351947">+91 99943 51947</a>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2026 Prime Rehab Industries. All rights reserved.</p>
                    <p className="footer-credit">
                        Designed by <a href="https://ascentbw.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>ascent brandworks</a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
